enum BackgroundDataAttribute {
	deps = 'data-deps', // is set to element to allow a server to add background slider resources to publication dependencies
}

export const getBackgroundDeps = (htmlDocument: Document): string[] | undefined => {
	const wrapperDiv = htmlDocument.body.firstElementChild as HTMLElement;
	const depsAttr = wrapperDiv.getAttribute(BackgroundDataAttribute.deps);

	return depsAttr ? depsAttr.split(';') : undefined;
};

export const saveBackgroundDeps = (htmlDocument: Document, deps?: string[]): void => {
	const wrapperDiv = htmlDocument.body.firstElementChild as HTMLElement;

	if (deps && deps.length > 0) {
		wrapperDiv.setAttribute(BackgroundDataAttribute.deps, deps.join(';'));
	} else {
		wrapperDiv.removeAttribute(BackgroundDataAttribute.deps);
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/backgroundDeps.ts